export const DEFAULT_MARGIN = 30;

/*
  The door builder prices off (100 - margin), so an empty or out-of-range
  value can't be allowed to reach it. MarginChip reverts to the last good
  value rather than letting one escape the editor.
*/
export const isMarginValid = (margin) => {
  if (margin === "" || margin === null || margin === undefined) return false;
  const value = Number(margin);
  return Number.isFinite(value) && value >= 0 && value < 100;
};
